import { takeLatest } from 'redux-saga/effects';
import fetchShopPriceListWorker from './shopPriceListWorkerSaga';
import {
    SHOP_PRICE_LIST_REQUEST,
} from '../../redux/modules/shopPriceList/shopPriceList-actions';

function* fetchShopPriceLIstWatcher() {
    yield takeLatest(SHOP_PRICE_LIST_REQUEST, fetchShopPriceListWorker);
}

export default fetchShopPriceLIstWatcher;
